import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Spinner } from "reactstrap";
import { performClientLogout } from "../../../services/logout";

const Logout = () => {
	const [done, setDone] = useState(false);

	useEffect(() => {
		let cancelled = false;
		(async () => {
			await performClientLogout();
			if (!cancelled) {
				setDone(true);
			}
		})();
		return () => {
			cancelled = true;
		};
	}, []);

	if (done) {
		return <Navigate to="/auth/login" replace />;
	}

	return (
		<div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
			<Spinner />
		</div>
	);
};

export default Logout;
